import { create } from "zustand"

interface UIState {
  isMobileMenuOpen: boolean
  activePillIndex: number

  setMobileMenuOpen: (open: boolean) => void
  toggleMobileMenu: () => void
  setActivePillIndex: (index: number) => void
}

export const useUIStore = create<UIState>((set) => ({
  isMobileMenuOpen: false,
  activePillIndex: 0,

  setMobileMenuOpen: (open) => set({ isMobileMenuOpen: open }),
  toggleMobileMenu: () =>
    set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  setActivePillIndex: (index) => set({ activePillIndex: index }),
}))
